import type { ValidationMessages } from './validation-i18n';

// English validation messages
export const enMessages: ValidationMessages = {
  required: (field) => (field ? `${field} is required` : 'This field is required'),
  email: () => 'Please enter a valid email address',
  phone: () => 'Please enter a valid phone number',
  url: () => 'Please enter a valid URL',
  minLength: (field, min) => `${field} must be at least ${min} characters`,
  maxLength: (field, max) => `${field} must be at most ${max} characters`,
  minValue: (field, min) => `${field} must be at least ${min}`,
  maxValue: (field, max) => `${field} must be at most ${max}`,
  invalidFormat: (field) => `${field} is not in a valid format`,
  tcKimlikInvalid: () => 'Invalid Turkish ID number',
  tcKimlikLength: () => 'Turkish ID must be 11 digits',
  taxNumberLength: () => 'Tax number must be 10 digits',
  taxNumberFormat: () => 'Please enter a valid tax number',
  dateRequired: () => 'Date selection is required',
  invalidDate: () => 'Please select a valid date',
  passwordMin: (min) => `Password must be at least ${min} characters`,
  numeric: () => 'Only numbers are allowed',
  alphanumeric: () => 'Only letters and numbers are allowed',
  usernameFormat: () => 'Username can only contain letters, numbers, hyphens and underscores',
  usernameLength: (min, max) => `Username must be between ${min} and ${max} characters`,
  futureDate: () => 'Please select a future date',
  pastDate: () => 'Please select a past date',
  dateInRange: (start, end) => `Date must be between ${start} and ${end}`,
  deliveryBeforePickup: () => 'Delivery date cannot be before pickup date',
  customerTypeRequired: () => 'Please select customer type',
  licenseClassRequired: () => 'Please select license class',
  positiveNumber: () => 'Please enter a positive number',
  integerRequired: () => 'Please enter a whole number',
};
